<template>
  <div class="flex">
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label>{{ $t('title') }}</label>
        <b-input class="input-pentagro" v-model="node.title"></b-input>
      </div>

      <span v-if="this.node.buttons.length">
        <div 
          class="mt-2 manage-buttons" 
          v-for="(button, i) in this.node.buttons" 
          :key="'b-'+i">
          <b-icon class="btn-icon" :title="$t('remover-botao')" icon="dash-circle-fill"  @click="askRemoveButton(i)"/>
          <div>
            <TextToInputVue 
              class="mt-1 mb-1"
              :text="button.caption"
              @sendText="button.caption = $event">
            </TextToInputVue>
            <input class="button-value" type="text" v-model="button.value" @keydown="()=>formatValue(button)">
          </div>
        </div>
      </span>
      <span v-else >{{ $t('sem-botoes-configurados') }}</span>
      
      <div class="add-button">
        <b-icon
          icon="plus-circle-fill"
          @click="addButton()"
          :title="$t('adicionar-novo-botao')"
          aria-hidden="true"
        />
      </div>
    </b-form>

    <div class="select-propertie">
      <SelectPropertie
        :node="node"
        @typeSelected="node.dataType = $event"
        @propSelected="node.data = $event"
        >
      </SelectPropertie>
    </div>

    <b-modal
      id="askRemoveButton"
      size="md"
      hide-footer
      :title="$t('alert')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :question="$t('wantDeleteButtom')"
        v-bind:action="removeButton"
        modelname="askRemoveButton"
      />
    </b-modal>
  </div>
</template>

<script>
import SelectPropertie from "../../dialogForm/template/SelectPropertie.vue"
import TextToInputVue from "../../../template/TextToInput.vue"
import ButtonSelect from './buttonSelected'
import MessageBox from "../../../template/MessageBoxModal.vue";

export default {
  props: {
    node: {
      type: Object,
      default: null
    }
  },

  components:{
    SelectPropertie,
    TextToInputVue,
    MessageBox
  },

  data() {
    return {
      transientIndex: -1
    }
  },

  watch:{
    value(){
      this.node.attrs[0].value = this.value;
    },
    title(){
      this.node.title = this.title;
    },

    attrSelected(value){
      if(value == "null") return
      this.value = String(this.attrsMap.get(this.attrSelected).value).replace(",", ".")
      this.node.attrs = [this.attrsMap.get(this.attrSelected)];
    },
  },

  methods: {
    askRemoveButton(i){
      this.transientIndex = i
      this.$bvModal.show("askRemoveButton");    
    },

    formatValue(button){
      button.value = button.value.replace(/[^a-z0-9.,]/gi, "")
      if(button.value.includes(".") && button.value.includes(","))
        button.value =  button.value.replace(/\./g, "")
      button.value = button.value.replace(/,/g, ".")
    },

    removeButton(){
      this.node.buttons.splice(this.transientIndex, 1);
    },

    addButton(){
      let newBotton = new ButtonSelect({caption:this.$t('novo-botao'), value: "0"})
      this.node.buttons.push(newBotton)
    }
  },
  
  mounted(){
  }
}
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}

svg{
  cursor: pointer;
}

.flex{
  display: flex;
}

.select-propertie{
  padding: 8px 0px 5px 8px;
  height: 270px;
}

.manage-buttons{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 270px;
}

.manage-buttons > div{
  padding-left: 10px;
  width: 100%;
}

.button-value{
  width: 100%;
}

.manage-buttons svg{
  color: #000;
}

.add-button svg{
  margin-top: 8px;
  margin-left: calc(50% - 12.5px);
  align-self: center;
  font-size: 25px;
}

</style>